<template>
  <div>
    <conn-config v-if="!isConfigured" :open="!isConfigured" :cancel="isConfigured"></conn-config>
    <v-content v-else>
      <v-tabs v-model="tab" grow>
        <v-tab href="#tab-Contacts">
          <v-icon class="mr-2">mdi-account-box</v-icon>Atendimento
        </v-tab>
        <v-tab href="#tab-Home">
          <v-icon class="mr-2">mdi-dialpad</v-icon>Home
        </v-tab>

        <v-tab href="#tab-History">
          <v-icon class="mr-2">mdi-history</v-icon>Histórico
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-Home">
          <Home />
        </v-tab-item>
        <v-tab-item value="tab-History">
          <Historico />
        </v-tab-item>
        <v-tab-item value="tab-Contacts">
          <div v-if="!atendimento">
            <v-card style="background:#F7F7F7; height:90vh; padding:40px" outlined>
              <v-img
                class="mt-10"
                v-if="!atendimento"
                src="../assets/fundowhats.jpeg"
                aspect-ratio="2"
                contain
              ></v-img>
              <h5 style="text-align:center; color:#666">Xcontact Omni Channel</h5>
              <p
                style="text-align:center !important; color:#666"
              >A solução completa para gestão de fluxos de atendimento multi canais!</p>
            </v-card>
          </div>
          <chat
            v-if="conectado && atendimento && atendimento !== null && atendimento.queueTypeID !== 1"
          ></chat>
          <ligacao
            v-if="conectado && atendimento && atendimento !== null && atendimento.queueTypeID == 1"
          ></ligacao>
        </v-tab-item>
      </v-tabs-items>
    </v-content>
    <!-- <v-footer absolute class="overline">
      <div>
        <v-icon small class="mr-2" color="green">mdi-checkbox-marked-circle</v-icon>Online
      </div>
      <v-spacer></v-spacer>
      <div>{{ramal}}</div>
    </v-footer>-->
  </div>
</template>
   
<script>
import Home from "./Home";
import ConnConfig from "./ConnConfig";
import Historico from "./Historico";
import { mapActions } from "vuex";
import { mapState } from "vuex";
import chat from "./Chat";
import ligacao from "./Ligacao";

export default {
  name: "Phone",
  components: {
    Home,
    ConnConfig,
    Historico,
    chat,
    ligacao
  },
  data: () => ({
    tab: null,
    isConfigured: true,
    ramal: ""
  }),
  computed: {
    ...mapState("auth", {
      token: state => state.token,
      status: state => state.status
    }),
    ...mapState("xc", {
      conectado: state => state.conectado,
      loading: state => state.loading,
      atendimento: state => state.atendimento,
      cliente: state => state.cliente
    })
  },
  methods: {
    ...mapActions("xc", [
      "getAtendimentos",
      "getAllAtendimentos",
      "getClientes",
      "addAgentes",
      "getDefault",
      "addFilas",
      "addPausas"
    ]),
    ...mapActions("auth", ["getLocalStorage"])
  }
};
</script>